import ScoreCardsTable from './ScoreCardsTable';

export default ScoreCardsTable;


// WEBPACK FOOTER //
// ./src/features/score-card/components/score-cards-table/index.js